import {css} from 'lit'; export default css`:host(.standalone){position:absolute;left:var(--goto-spacing-04);top:0}img{display:block;height:var(--goto-spacing-06);width:auto}chameleon-goto-logo{--goto-icon-size:var(--goto-layout-05)}`;
    